// extracted by mini-css-extract-plugin
export default {"typeahead":"countries_typeahead__wYv09"};